import { Control } from "react-hook-form";

import Stack from "@mui/material/Stack";
import type { SxProps } from "@mui/material/styles";

import InputFormField from "components/input-form-field";

import { InventoryProductSpecificationValues } from "../inventory-product-specification-form.component";

export type ReceiverSpecificationValues = {
  gain: string;
  length: number | string;
  additional_notes: string;
};

export const EMPTY_RECEIVER_SPECIFICATION: ReceiverSpecificationValues = {
  gain: "",
  length: "",
  additional_notes: ""
};

type ReceiverSpecificationFormProps = {
  control: Control<InventoryProductSpecificationValues, object>;
  sx?: SxProps;
};

export default function ReceiverSpecificationForm({
  control,
  sx
}: ReceiverSpecificationFormProps) {
  return (
    <>
      <Stack direction="row" sx={{ width: "100%", ...sx }} spacing={2}>
        <InputFormField
          name="receiver.gain"
          label="Gain"
          placeholder=""
          control={control}
          sx={{ ml: 0 }}
        />
        <InputFormField
          name="receiver.length"
          type="number"
          label="Length"
          placeholder=""
          control={control}
          rules={{ min: { value: 0, message: "value have to be above 0" } }}
          sx={{ ml: 0 }}
        />
      </Stack>
      <InputFormField
        name="receiver.additional_notes"
        label="Additional notes"
        control={control}
        sx={{ ml: 0, mt: 4 }}
        multiline
      />
    </>
  );
}
